<template lang="pug">
.barcode-scanner
    .barcode-scanner__bar
        span.barcode-scanner__title {{ $t('Barcode scannen') }}
        button.barcode-scanner__close(type="button" @click="$emit('close')")
            i.el-icon-close

    .barcode-scanner__stage
        stream-barcode-reader(
            @decode="onDetected"
            @loaded="onLoaded"
        )
        .barcode-scanner__loading(v-if="!ready")
            i.el-icon-loading
            span {{ $t('Kamera wird gestartet…') }}

    .barcode-scanner__foot
        .barcode-scanner__hint {{ $t('EAN / GTIN oder SKU in den Rahmen halten') }}
</template>

<i18n>
{
  "de": {
    "Barcode scannen": "Barcode scannen",
    "Kamera wird gestartet…": "Kamera wird gestartet…",
    "EAN / GTIN oder SKU in den Rahmen halten": "EAN / GTIN oder SKU in den Rahmen halten"
  }
}
</i18n>

<script>
import { StreamBarcodeReader } from 'vue-barcode-reader'

export default {
    name: 'BarcodeScanner',
    components: { StreamBarcodeReader },
    data() {
        return {
            ready: false,
            handled: false,
        }
    },
    methods: {
        onLoaded() {
            this.ready = true
        },
        onDetected(text) {
            const code = (text || '').trim()
            /* eslint-disable-next-line no-console */
            console.log('[Barcode] EAN/Code:', code)
            if (this.handled) return // nur den ersten Treffer verarbeiten (ZXing feuert mehrfach)
            if (!code) return
            this.handled = true
            this.$emit('detected', code)
        },
    },
}
</script>

<style lang="sass" scoped>
.barcode-scanner
    position: fixed
    inset: 0
    z-index: 3000
    background: #000
    display: flex
    flex-direction: column

.barcode-scanner__bar
    flex-shrink: 0
    height: 52px
    display: flex
    align-items: center
    justify-content: space-between
    padding: 0 16px
    background: #111
    border-bottom: 1px solid #222

    .barcode-scanner__title
        font-size: 15px
        font-weight: 600
        color: #d0d0d0

    .barcode-scanner__close
        border: none
        background: none
        color: #888
        font-size: 22px
        cursor: pointer
        padding: 6px
        -webkit-tap-highlight-color: transparent

.barcode-scanner__stage
    flex: 1
    min-height: 0
    position: relative
    overflow: hidden
    display: flex
    align-items: center
    justify-content: center

    // Das StreamBarcodeReader-Video die ganze Fläche füllen lassen
    ::v-deep .scanner-container
        width: 100%
        height: 100%
        display: flex
        align-items: center
        justify-content: center

        > div
            width: 100%
            height: 100%

    ::v-deep video
        width: 100% !important
        height: 100% !important
        object-fit: cover

    .barcode-scanner__loading
        position: absolute
        inset: 0
        z-index: 3
        display: flex
        flex-direction: column
        align-items: center
        justify-content: center
        gap: 10px
        color: #aaa
        background: #000
        i
            font-size: 30px

.barcode-scanner__foot
    flex-shrink: 0
    padding: 14px 16px calc(14px + env(safe-area-inset-bottom))
    background: #111
    border-top: 1px solid #222
    text-align: center

    .barcode-scanner__hint
        font-size: 12px
        color: #777
</style>
